import { Alert, alpha, useTheme } from "@mui/material";

export default function ModulesAlert({}) {
  let modulos = localStorage.getItem("modulos") || "{}";
  modulos = typeof modulos === "string" ? JSON.parse(modulos) : modulos;
  const modulosError = modulos?.error || false;
  const theme = useTheme();
  const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES;
  const styles = {
    alertWarning: {
      display: "flex",
      width: "100%",
      //mt: 1,
      height: "fit-content",
      borderRadius: 0,
      justifyContent: "center",
      alignItems: "center",
      paddingY: 0,
      backgroundColor: alpha(theme.palette.warning.main, 0.4),
    },
    alertError: {
      display: "flex",
      width: "100%",
      //mt: 1,
      height: "fit-content",
      borderRadius: 0,
      justifyContent: "center",
      alignItems: "center",
      paddingY: 0,
      backgroundColor: alpha(theme.palette.error.main, 0.4),
    },
  };
  return verifyModules === "true" ? (
    modulos?.status === 2 ? (
      <Alert severity="error" sx={styles.alertError}>
        Atenção: faz um tempo que não é feita nenhuma conexão com o sistema MW,
        o acesso aos produtos foi bloqueado. Por favor, verifique sua conexão ou
        entre em contato com o nosso suporte.
      </Alert>
    ) : modulos?.status === 1 ? (
      <Alert severity="warning" sx={styles.alertWarning}>
        Alerta: por mais de 3 dias não é feita nenhuma conexão com o sistema
        interno, em breve o acesso aos produtos será bloqueado. Por favor,
        verifique sua conexão ou entre em contato com o nosso suporte.
      </Alert>
    ) : modulosError ? (
      <Alert severity="error" sx={styles.alertError}>
        {
          "Falha na conexão com o Sistema MW. Por favor, verifique sua conexão ou entre em contato com o nosso suporte."
        }
      </Alert>
    ) : modulosError ? (
      <Alert severity="error" sx={styles.alertError}>
        {
          "Falha na conexão com o Sistema MW. Por favor, verifique sua conexão ou entre em contato com o nosso suporte."
        }
      </Alert>
    ) : null
  ) : null;
}
